export class JobInfo {
    id: string;
    title: string;
    jobPosterAccountId: string;

    public static parse(json): JobInfo {
        let jobInfo = new JobInfo();
        Object.assign(jobInfo, json);
        return jobInfo;
    }
}